import GeneralMapper from "./General_Mapper";

const tableroMapper = async (data) => {
  let responseData = [];
  for (var i = 0; i < data.data.length; i++) {
    responseData[i] = {
      id: data.data[i].idTablero ?? "",
      Nombre: data.data[i].nombreTablero ?? "",
      Descripcion: data.data[i].descripcion ?? "",
      fechacreacion: data.data[i].fechacreacion ?? "",
    };
    responseData.push();
  }
  return GeneralMapper.successMapper(responseData, data.totalRows);
};

const tableroByIdMapper = async (data) => {
  const responseData = {
    id: data.idTablero ?? "",
    nombreTablero: data.nombreTablero ?? "",
    descripcion: data.descripcion ?? "",
    urlReporte: data.urlReporte ?? "",
    urlEmbedded: data.urlEmbedded ?? "",
    listTablero: data.listTablero ?? "",
    idReporte: data.idReporte ?? "",
    idDataset: data.idDataset ?? "",
    fechaReporteActualizado: data.fechaReporteActualizado ?? ""
  };
  return GeneralMapper.successMapper(responseData, 0);
};

const areasMapper = async (data) => {
  let responseData = [];
  for (var i = 0; i < data.data.length; i++) {
    responseData[i] = {
      id: data.data[i].idArea ?? "",
      Nombre: data.data[i].nombreArea ?? "",
      Id: data.data[i].idReporte ?? "",
      Descripcion: data.data[i].descripcion ?? "",
      Fecha: data.data[i].fechacreacion ?? "",
    };
    responseData.push();
  }
  return GeneralMapper.successMapper(responseData, data.totalRows);
};

const areasByIdMapper = async (data) => {
  const responseData = {
    id: data.idArea ?? "",
    nombreArea: data.nombreArea ?? "",
    idReporte: data.idReporte ?? "",
    descripcion: data.descripcion ?? "",
    listTablero: data.listTablero ?? "",
  };
  return GeneralMapper.successMapper(responseData, 0);
};

const areasByIdBIMapper = async (data) => {
  let responseData = [];
  for (var i = 0; i < data.length; i++) {
    responseData[i] = {
      id: data[i].idTablero ?? "",
      Nombre: data[i].nombreTablero ?? "",
      Descripcion: data[i].descripcionTablero ?? "",
    };
    responseData.push();
  }
  return GeneralMapper.successMapper(responseData, data.length);
};

const tableroByRolByUserMapper = async (data) => {
  const responseData = {
    descripcion: data.descripcion ?? "",
    esActivo: data.esActivo ?? "",
    idArea: data.idArea ?? "",
    idTablero: data.idTablero ?? "",
    listRoles: data.listRoles ?? "",
    listUsuario: data.listUsuario ?? "",
    nombreTablero: data.nombreTablero ?? "",
  };
  return GeneralMapper.successMapper(responseData, 0);
};

const areasNewBiMapper = async (data) => {
  let responseData = [];
  for (var i = 0; i < data.rows.length; i++) {
    responseData[i] = {
      id: data.rows[i].idArea ?? "",
      Nombre: data.rows[i].nombreArea ?? "",
      Id: data.rows[i].idReporte ?? "",
      Descripcion: data.rows[i].descripcion ?? "",
      Fecha: data.rows[i].fechacreacion ?? "",
    };
    responseData.push();
  }
  return GeneralMapper.successMapper(responseData, data.totalRows);
};

const areasNewByIdBIMapper = async (data) => {
  let responseData = [];
  for (var i = 0; i < data.length; i++) {
    responseData[i] = {
      id: data[i].idTablero ?? "",
      Nombre: data[i].nombreTablero ?? "",
      Descripcion: data[i].descripcionTablero ?? "",
    };
    responseData.push();
  }
  return GeneralMapper.successMapper(responseData, data.length);
};

const tableroXAreasNewBiMapper = async (data) => {
  let responseData = [];
  for (var i = 0; i < data.rows.length; i++) {
    responseData[i] = {
      id: data.rows[i].idTablero ?? "",
      Nombre: data.rows[i].nombreTablero ?? "",
      codigoUsuario: data.rows[i].codigoUsuario ?? "",
      Area: data.rows[i].nombreArea ?? "",
      Descripcion: data.rows[i].descripcion ?? "",
      nombreTablero: data.rows[i].nombreTablero ?? "",
      urlTablero: data.rows[i].urlTablero ?? "",
      esFavorito: data.rows[i].esFavorito
    };
    responseData.push();
  }
  return GeneralMapper.successMapper(responseData, data.totalRows);
};

const empresasMapper = async (data) => {
  let responseData = [];
  for (var i = 0; i < data.listEmpresa.length; i++) {
    responseData[i] = {
      id: data.listEmpresa[i].idEmpresa ?? "",
      Identificación: data.listEmpresa[i].ruc ?? "",
      Nombre: data.listEmpresa[i].nombreEmpresa ?? "",
      Siglas: data.listEmpresa[i].siglasEmpresa ?? "",
      Representante: data.listEmpresa[i].nombreRepresentanteLegal ?? "",
      Dirección: data.listEmpresa[i].direccion ?? "",
    };
    responseData.push();
  }
  return GeneralMapper.successMapper(responseData, data.totalRows);
};

const empresasyIdMapper = async (data) => {
  const responseData = {
    id: data.idEmpresa ?? "",
    nombreEmpresa: data.nombreEmpresa ?? "",
    codigoTipoIdentificacion: data.codigoTipoIdentificacion ?? "",
    numeroIdentificacion: data.numeroIdentificacion ?? "",
    ruc: data.ruc ?? "",
    ruc: data.ruc ?? "",
    idGrupoEmpresa: data.idGrupoEmpresa ?? "",
    direccion: data.direccion ?? "",
    siglasEmpresa: data.siglasEmpresa ?? "",
    nombreRepresentanteLegal: data.nombreRepresentanteLegal ?? "",
    esActivo: data.esActivo ?? "",
  };
  return GeneralMapper.successMapper(responseData, 0);
};

const usuariosConfigMapper = async (data) => {
  let responseData = [];
  for (var i = 0; i < data.listPersonal.length; i++) {
    responseData[i] = {
      idEmpresa: data.listPersonal[i].idEmpresa ?? "",
      id: data.listPersonal[i].secuenciaPersonal ?? "",
      Identificación: data.listPersonal[i].numeroIdentificacion ?? "",
      Nombre: data.listPersonal[i].nombreUsuario ?? "",
      Código: data.listPersonal[i].codigoUsuario ?? "",
      Email: data.listPersonal[i].email ?? "",
      Nacimiento: data.listPersonal[i].fechaDeNacimiento ?? "",
      Estado: data.listPersonal[i].esActivo === "S" ?  "Activo" : "Inactivo",
    };
    responseData.push();
  }
  return GeneralMapper.successMapper(responseData, data.totalRows);
};

const usuariosConfigIdMapper = async (data) => {
  const responseData = {
    idEmpresa: data.idEmpresa ?? "",
    id: data.secuenciaPersonal ?? "",
    identificacion: data.numeroIdentificacion ?? "",
    primerNombre: data.primerNombre ?? "",
    segundoNombre: data.segundoNombre ?? "",
    primerApellido: data.primerApellido ?? "",
    segundoApellido: data.segundoApellido ?? "",
    codigo: data.codigoUsuario ?? "",
    email: data.email ?? "",
    sexo: data.sexo ?? "",
    esActivo: data.esActivo ?? "",
    nacimiento: data.fechaDeNacimiento ?? "",
  };
  return GeneralMapper.successMapper(responseData, 0);
};

const groupMapper = async (data) => {
  let responseData = [];
  for (var i = 0; i < data.listGrupoEmpresa.length; i++) {
    responseData[i] = {
      id: data.listGrupoEmpresa[i].idGrupoEmpresa ?? "",
      Nombre: data.listGrupoEmpresa[i].nombreGrupo ?? "",
      Descripción: data.listGrupoEmpresa[i].descripcionGrupo ?? "",
      Creación: data.listGrupoEmpresa[i].fechaCreacion ?? "",
    };
    responseData.push();
  }
  return GeneralMapper.successMapper(responseData, data.totalRows);
};

const groupIdMapper = async (data) => {
  const responseData = {
    id: data.idGrupoEmpresa ?? "",
    nombreGrupo: data.nombreGrupo ?? "",
    descripcionGrupo: data.descripcionGrupo ?? "",
    esActivo: data.esActivo ?? "",
  };
  return GeneralMapper.successMapper(responseData, 0);
};

const areasRecFavMapper = async (data) => {
  let responseData = [];
  for (var i = 0; i < data.data.length; i++) {
    responseData[i] = {
      id: data.data[i].idTablero ?? "",
      Nombre: data.data[i].nombreTablero ?? "",
      Descripcion: data.data[i].descripcion ?? "",
      Area: data.data[i].nombreArea ?? "",
      fechacreacion: data.data[i].fechacreacion ?? "",
      esFavorito: data.data[i].esFavorito ?? "",
    };
    responseData.push();
  }
  return GeneralMapper.successMapper(responseData, data.data.length);
};

const configuracionMapper = {
  tableroMapper,
  tableroByIdMapper,
  areasMapper,
  areasByIdMapper,
  areasByIdBIMapper,
  tableroByRolByUserMapper,
  areasNewBiMapper,
  areasNewByIdBIMapper,
  tableroXAreasNewBiMapper,
  empresasMapper,
  empresasyIdMapper,
  usuariosConfigMapper,
  usuariosConfigIdMapper,
  groupMapper,
  groupIdMapper,
  areasRecFavMapper
};

export default configuracionMapper;
